(() => {
  'use strict';
  const node = document.querySelector('[data-school-navigation-config]');
  if (!node) return;
  const config = JSON.parse(node.textContent);
  const directory = new Map(config.directory.map(s => [s.url.split('/').pop(), s.name]));
  const rules = config.rules;
  const keys = ['program', 'gender', 'grade', 'sport'];
  const names = {uniform:'Uniform',spiritwear:'Spirit Wear',team:'Team',drama:'Drama',classof:'Class Of',alumni:'Alumni',boys:'Boys',girls:'Girls'};
  const label = v => names[v] || v.split('-').map(w => w[0].toUpperCase() + w.slice(1)).join(' ');
  const current = new URL(location.href);
  const previewId = current.searchParams.get('preview_theme_id') || (['unpublished','development','demo'].includes(config.themeRole) ? String(config.themeId) : '');
  function context(school, values) {
    if (!directory.has(school)) return null;
    const program = values.program || '';
    if (program && !(rules.programs[school] || []).includes(program)) return null;
    if (values.gender && !['boys','girls'].includes(values.gender)) return null;
    const schoolGender = rules.genders[directory.get(school)];
    if (values.gender && schoolGender && values.gender !== schoolGender) return null;
    if (values.grade && !(rules.grades[school] || []).includes(values.grade)) return null;
    if (values.sport && (program !== 'team' || !(rules.sports[school] || []).includes(values.sport))) return null;
    const selected = {program};
    if (program === 'team') {
      if (values.gender || values.grade) return null;
      if (values.sport) selected.sport = values.sport;
    } else if (rules.genderless.includes(program)) {
      // Existing eligibility ignores these for genderless programs; do not invent a requirement.
    } else {
      if (values.gender) selected.gender = values.gender;
      if (values.grade && !rules.genderOnly.includes(program)) selected.grade = values.grade;
    }
    let complete = !!program;
    if (program === 'team') complete = complete && (!(rules.sports[school] || []).length || !!selected.sport);
    else if (!rules.genderless.includes(program)) {
      complete = complete && !!selected.gender;
      if (!rules.genderOnly.includes(program) && (rules.grades[school] || []).length) complete = complete && !!selected.grade;
    }
    return {school, values:selected, complete};
  }
  function read(prefix) {
    const values = {};
    for (const key of keys) {
      if (current.searchParams.getAll(prefix + key).length > 1) return null;
      values[key] = current.searchParams.get(prefix + key) || '';
    }
    return values;
  }
  function returnURL(c) {
    let path = '/collections/' + c.school;
    if (c.values.program === 'team') path += '/program-team' + (c.values.sport && c.values.sport !== 'all-sports' ? '+sport-' + c.values.sport : '');
    const url = new URL(path, location.origin);
    for (const key of keys) if (c.values[key]) url.searchParams.set(key, c.values[key]);
    const preview = previewId;
    if (preview && /^\d+$/.test(preview)) url.searchParams.set('preview_theme_id', preview);
    return url.pathname + url.search;
  }
  function productLink(a, c) {
    const url = new URL(a.href, location.origin);
    if (url.origin !== location.origin || !/\/products\/[^/]+$/.test(url.pathname)) return;
    const pathSchool = url.pathname.match(/^\/collections\/([^/]+)\/products\//)?.[1];
    if (pathSchool && pathSchool !== c.school) return;
    const variant = url.searchParams.get('variant');
    const clean = new URL(url.pathname, location.origin);
    if (variant && /^\d+$/.test(variant)) clean.searchParams.set('variant', variant);
    clean.searchParams.set('ls_school', c.school);
    for (const key of keys) if (c.values[key]) clean.searchParams.set('ls_' + key, c.values[key]);
    const preview = previewId;
    if (preview && /^\d+$/.test(preview)) clean.searchParams.set('preview_theme_id', preview);
    const href = clean.pathname + clean.search;
    if (a.getAttribute('href') !== href) a.setAttribute('href', href);
  }
  const storageKey = 'liebmans.schoolSelection.' + config.themeId;
  function remember(c) {
    try {
      if (c?.complete) sessionStorage.setItem(storageKey,JSON.stringify({school:c.school,values:c.values,time:Date.now()}));
      else sessionStorage.removeItem(storageKey);
    } catch (_) {}
  }
  function remembered() {
    try {
      const saved = JSON.parse(sessionStorage.getItem(storageKey));
      if (!saved || !Number.isFinite(saved.time) || Date.now()-saved.time > 3600000 || saved.time > Date.now()) return null;
      return context(saved.school,saved.values);
    } catch (_) { return null; }
  }
  function previewURL(url) {
    const preview = previewId;
    if (preview && /^\d+$/.test(preview)) url.searchParams.set('preview_theme_id',preview);
    return url;
  }
  function cartReturn() {
    const supplied = ['school',...keys].some(k=>current.searchParams.has('ls_'+k));
    const values = read('ls_');
    const c = supplied ? (values && current.searchParams.getAll('ls_school').length === 1 ? context(current.searchParams.get('ls_school'),values) : null) : remembered();
    if (supplied) remember(c);
    const fallback = previewURL(new URL('/#school-search',location.origin));
    const apply = data => {
      const valid = data && Number.isInteger(data.count) && data.count === data.lines?.length && window.LiebmansSchoolEligibility?.coherent(c,data.lines,directory);
      const href = valid ? returnURL(c) : fallback.pathname+fallback.search+fallback.hash;
      document.querySelectorAll('[data-school-cart-return] a').forEach(a=>a.setAttribute('href',href));
    };
    apply(config.cart);
    let generation = 0;
    const refresh = async () => {
      const own = ++generation;
      apply(null);
      try {
        const url = previewURL(new URL('/cart?view=liebmans-context',location.origin));
        const response = await fetch(url,{credentials:'same-origin',cache:'no-store'});
        if (!response.ok) throw Error('Cart context unavailable');
        const doc = new DOMParser().parseFromString(await response.text(),'text/html');
        const data = JSON.parse(doc.querySelector('[data-public-cart-context]').textContent);
        if (own === generation) apply(data);
      } catch (_) { if (own === generation) apply(null); }
    };
    document.addEventListener('cart:updated',refresh);
    document.addEventListener('ajaxProduct:added',refresh);
    window.addEventListener('pageshow',e=>{if(e.persisted)refresh();});
  }

  function collectionContext() {
    const values = read('');
    if (!values) return null;
    const tags = decodeURIComponent(location.pathname.split('/')[3] || '').split('+');
    if (!values.program && tags.includes('program-team')) values.program = 'team';
    if (!values.sport) values.sport = (tags.find(t => t.startsWith('sport-')) || '').slice(6);
    return context(config.school, values);
  }
  const schoolCollection = config.page === 'collection' && directory.has(config.school);
  function prepareSelection(wrapper) {
    if (!schoolCollection || !wrapper || document.getElementById('school-selection-toggle')) return;
    wrapper.closest('.shopify-section')?.classList.add('school-selection-section');
    const c = collectionContext();
    const host = wrapper.querySelector('#selection-summary');
    if (!c?.complete || !host) return;
    const bar = document.createElement('div'); bar.className = 'school-selection-bar';
    const summary = document.createElement('p'); summary.className = 'school-selection-current';
    summary.textContent = [directory.get(c.school), ...keys.filter(k => c.values[k]).map(k => label(c.values[k]) + (k === 'grade' && /^\d/.test(c.values[k]) ? ' Grade' : ''))].join(' · ');
    const button = document.createElement('button'); button.type = 'button'; button.id = 'school-selection-toggle'; button.textContent = config.strings.change;
    button.setAttribute('aria-controls', 'selection-filters');
    button.addEventListener('click', () => {
      wrapper.classList.add('school-selection-open'); button.setAttribute('aria-expanded', 'true');
      const first = [...wrapper.querySelectorAll('#selection-filters select')].find(el => el.getClientRects().length);
      first?.focus();
    });
    const media = matchMedia('(max-width: 768px)');
    const aria = () => button.setAttribute('aria-expanded', String(!media.matches || wrapper.classList.contains('school-selection-open')));
    aria(); media.addEventListener('change', aria);
    bar.append(summary, button); host.prepend(bar);
    wrapper.classList.add('school-selection-complete');
  }
  if (schoolCollection) {
    document.documentElement.classList.add('school-page-layout');
    window.LiebmansSchoolLayout = {selection: prepareSelection};
  }

  function start() {
    if (config.page === 'cart') { cartReturn(); return; }
    const isCollection = config.page === 'collection';
    if (isCollection || ['school',...keys].some(k=>current.searchParams.has('ls_'+k)) || location.pathname.startsWith('/collections/')) remember(null);
    let c;
    if (isCollection) {
      c = collectionContext();
      if (!directory.has(config.school)) return;
      prepareSelection(document.getElementById('selection-wrapper'));
      if (!c) return; // Invalid/retired input never gets a remembered return context.
    } else if (config.page === 'product') {
      const values = read('ls_');
      const explicit = current.searchParams.get('ls_school');
      const pathSchool = location.pathname.match(/^\/collections\/([^/]+)\/products\//)?.[1];
      const school = explicit || pathSchool;
      if (!values || !school || current.searchParams.getAll('ls_school').length > 1 || (explicit && pathSchool && explicit !== pathSchool) || !config.productSchools.includes(school)) return;
      c = context(school, values);
      if (!c) return;
      const link = document.createElement('a'); link.className = 'school-context-return'; link.href = returnURL(c);
      link.textContent = config.strings.continue + ' ' + directory.get(school);
      const nav = document.createElement('nav'); nav.className = 'page-width school-context-nav'; nav.setAttribute('aria-label', config.strings.navigation); nav.append(link);
      document.getElementById('MainContent')?.prepend(nav);
    } else return;
    remember(c);
    window.LiebmansSchoolRecommendations?.(c, productLink, previewId);
    const patchLinks = () => {
      if (c.complete) document.querySelectorAll('a[href]').forEach(a => {
        const u = new URL(a.href, location.origin);
        if (u.origin !== location.origin || u.pathname !== '/cart') return;
        const clean = new URL('/cart',location.origin);
        clean.searchParams.set('ls_school',c.school);
        for (const key of keys) if (c.values[key]) clean.searchParams.set('ls_'+key,c.values[key]);
        previewURL(clean);
        const href = clean.pathname + clean.search;
        if (a.getAttribute('href') !== href) a.setAttribute('href',href);
      });
      if (isCollection) document.querySelectorAll('#CollectionAjaxContent a.grid-product__link').forEach(a => productLink(a,c));
      else {
        document.querySelectorAll('.return-link, .school-context-return').forEach(a => {
          const u = new URL(a.href,location.origin);
          if (u.origin === location.origin && u.pathname.split('/')[2] === c.school) {
            const value = returnURL(c); if (a.getAttribute('href') !== value) a.setAttribute('href',value);
          }
        });
        document.querySelectorAll('[data-liebmans-school-recommendations] a').forEach(a => {
          if (a.closest('[data-liebmans-school-recommendations]').dataset.liebmansSchoolRecommendations === c.school) productLink(a,c);
        });
      }
    };
    patchLinks();
    const observer = new MutationObserver(patchLinks);
    observer.observe(document.getElementById('MainContent'), {childList:true,subtree:true});
    window.addEventListener('pageshow',patchLinks);
  }
  if (document.readyState !== 'complete') document.addEventListener('DOMContentLoaded', start, {once:true}); else start();
})();
